import React from 'react'

export const Divider = ({ text, mt }: { text: string; mt?: 'mt-[24px]' }) => {
  return (
    <div className={`mx-auto mb-[20px] ${mt} flex w-11/12 items-center justify-center`}>
      <div className="h-[0.5px] w-[80%] bg-[#666]" />
      <span className="mx-[6px] whitespace-nowrap text-center text-[10px] font-light text-[#666]">{text}</span>
      <div className="h-[0.5px] w-[80%] bg-[#666]" />
    </div>
  )
}
